export default __webpack_public_path__ + "static/media/Raining_08.336ace50.png";